// @ts-nocheck
import { graphql } from '@apollo/client/react/hoc';
import { message } from "antd";
import { SET_DEFAULT_ORGANIZATION, UPDATE_DEFAULT_ORGANIZATION } from '../graphql/organisation.gql';

export const withSetDefaultOrganisation = Component =>
  graphql(SET_DEFAULT_ORGANIZATION, {
    props: ({ mutate }) => ({
      setDefaultOrganization: async values => {
        try {
          const {
            data: { setDefaultOrganization }
          } = await mutate({
            variables: {
              userOrganizationPreferenceData: values
            }
          });
          message.destroy();
          return setDefaultOrganization?.userOrganizationPreference?.id;
        } catch (e) {
          message.destroy();
          message.error("Couldn't perform the action");
          console.error("orgSelectOperation -> withSetDefaultOrganisation", e);
        }
      }
    })
  })(Component);

export const withUpdateDefaultOrganisation = Component =>
  graphql(UPDATE_DEFAULT_ORGANIZATION, {
    props: ({ mutate }) => ({
      updateDefaultOrganization: async values => {
        try {
          const {
            data: { updateDefaultOrganization }
          } = await mutate({
            variables: {
              ...values
            }
          });
          message && message.destroy();
          return updateDefaultOrganization?.userOrganizationPreference?.id;
        } catch (e) {
          message.destroy();
          message.error("Couldn't perform the action");
          console.error("orgSelectOperation -> withUpdateDefaultOrganisation", e);
        }
      }
    })
  })(Component);
